import moment from 'moment-timezone'
import momentDurationFormatSetup from 'moment-duration-format'
import 'moment/locale/pt-br'

momentDurationFormatSetup(moment)
moment.locale('pt-br')

export function formatToCustomDate (datetime, timezone = 'UTC', format = 'LLLL') {
  return moment.tz(datetime, timezone).format(format)
}

export function convertHourInSecondsAndMinutes (seconds) {
  return moment.duration(seconds, 'seconds').format('mm:ss')
}

export function convertSecondsToCustomTimeFormat (seconds, format = 'HH:mm:ss') {
  return moment.duration(seconds, 'seconds').format(format, {
    trim: false,
    useGrouping: false
  })
}

export function getDatetimeOnBeginningOfTheDayByDaysAgo (daysAgo = 1) {
  return new Date(moment().subtract(daysAgo, 'days').startOf('day'))
}

export function getDatetimeOnEndOfTheDayByDaysAgo (daysAgo = 1) {
  return new Date(moment().subtract(daysAgo, 'days').endOf('day'))
}

export function getDatetimeOnBeginningOfTheMonthByMonthsAgo (monthsAgo = 1, timezone = 'UTC') {
  return new Date(moment().tz(timezone).subtract(monthsAgo, 'months').startOf('month'))
}

export function getDatetimeOnEndOfTheMonthByMonthsAgo (monthsAgo = 1, timezone = 'UTC') {
  return new Date(moment().tz(timezone).subtract(monthsAgo, 'months').endOf('month'))
}



// WEBPACK FOOTER //
// ./src/utils/datetime.js